import './input-hidden.scss';
import InputWrapper from '../input-wrapper/input-wrapper';
import { useState } from 'react';
import Button from '../../button/button';
import { useTranslate } from "../../../features/translation/hooks/use-translation";

// TODO: Update is open to checkbox ? 

// Required props: label, name, placeholder, value (as placeholder), onReset

const InputHidden = (props) => {
    const [isOpen, setIsOpen] = useState(false)
    const { t } = useTranslate();

    console.debug('Re-rendering hidden input')

    const Modal = () => <div className='input-modal' style={{overflowAnchor: "none !important"}}>
        <div className='input-modal--backdrop' hidden={!isOpen} onClick={() => setIsOpen(false)}/>
        <div style={{ paddingLeft: "calc(50% - 0.75rem)" }} hidden={!isOpen}>
            <div className='input-modal--arrow' />
        </div>
        <div style={{position: "absolute", left: "0", right: "0", marginTop:"12px", minWidth:"100%", minHeight:"100hv"}} >
            <dialog className="input-dialog base " aria-modal="true" id={`dialog-${props.name}`} open={isOpen}>
                <form method="dialog" className='input-modal--content'>
                    <header className='content-header'>
                        <span className='title'>
                            <p className="text lead medium semibold nospace ">
                                {props.modalLabel || props.label}
                            </p>
                        </span>
                        <span className="control">
                            <button className="icon-button primary medium" type="button" onClick={() => setIsOpen(false)} title="Icon Button">
                                <span className="icon " style={{WebkitMaskImage: "url(https://static.tui.com/assets/v2/icons/tui-light/cross.svg)", maskImage: "url(https://static.tui.com/assets/v2/icons/tui-light/cross.svg)", color: "currentColor"}}></span>
                            </button>
                        </span>
                    </header>
                    <section className='main' >
                        {props.children}
                    </section>
                    <menu className='footer'  style={{ display:"flex", gap:"var(--space-4)", justifyContent: "flex-end"}}>
                        {props.onReset && <Button label={"reset"} className="ghost medium" onClick={() => {props.onReset()}} style={{border: 0, textDecoration: "underline"}}/>}
                        <Button label={t("input.button.close")} className="primary medium" onClick={() => setIsOpen(false)}/>
                        
                    </menu>
                </form>
            </dialog>
        </div>
    </div>

    return (
        <div>
            <InputWrapper {...props} inputType="text" className={`${isOpen ? 'active': ''}`} >
                <div className='group input-hidden--field' data-label="input"  onClick={() => { !props.disabled && setIsOpen(!isOpen)}} >
                    {props.leadingIcon &&
                        <span className="icon-leading">
                            <span className="icon medium" style={{
                                WebkitMaskImage: `url(https://static.tui.com/assets/v2/icons/tui-light/${props.leadingIcon}.svg)`,
                                maskImage: `url(https://static.tui.com/assets/v2/icons/tui-light/${props.leadingIcon}.svg)`,
                                color: "currentColor"
                            }}>
                            </span>
                        </span>}
                    <input
                        id={props.id || props.name}
                        style={{ 
                            cursor: "pointer",
                            overflow: "hidden",
                            textOverflow: "ellipsis", // Or replace "ellipsis" with your desired string
                            whiteSpace: "nowrap" 
                        }}
                        type="text"
                        placeholder={props.placeholder}
                        value={props.value}
                        readOnly
                        disabled={props.disabled}
                    />
                    {props.trailingIcon &&
                        <span className="icon-trailing" >
                            <span className="icon medium" style={{
                                WebkitMaskImage: `url(https://static.tui.com/assets/v2/icons/tui-light/${props.trailingIcon}.svg)`,
                                maskImage: `url(https://static.tui.com/assets/v2/icons/tui-light/${props.trailingIcon}.svg)`,
                                color: "currentColor"
                            }}
                            >
                            </span>
                        </span>
                    }
                </div>
            </InputWrapper>
            <Modal/>
        </div>
    )
};

export default InputHidden;